import React from "react";
import { MapPin, Phone, Mail, Instagram, Zap } from "lucide-react";
import { BUSINESS } from "@/data/business";

export default function Footer() {
  return (
    <footer className="bg-slate-900 text-slate-300" data-testid="site-footer">
      <div className="container-b py-14">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-4">
          <div className="md:col-span-2">
            <div className="flex items-center gap-2.5">
              <span className="inline-flex h-9 w-9 items-center justify-center rounded-xl bg-blue-600 text-white">
                <Zap className="h-5 w-5" strokeWidth={2.4} />
              </span>
              <span className="font-heading text-lg font-extrabold text-white">
                Bhadani Electronics
              </span>
            </div>
            <p className="mt-4 max-w-md text-sm leading-relaxed text-slate-400">
              {BUSINESS.name} — your trusted store for electronics, home appliances and furniture
              in Fatehpur, Gaya. Genuine products, honest prices, personal service.
            </p>

            <div className="mt-6 inline-flex items-center gap-3 rounded-full border border-slate-700 bg-slate-800/60 px-4 py-2">
              <span className="text-[10px] font-bold uppercase tracking-[0.2em] text-slate-400">GSTIN</span>
              <span className="font-mono text-sm font-semibold text-white" data-testid="footer-gst">
                10BZDPB2001B2ZU
              </span>
            </div>
          </div>

          <div>
            <div className="font-heading text-sm font-bold uppercase tracking-[0.2em] text-white">
              Contact
            </div>
            <ul className="mt-5 space-y-4 text-sm">
              <li className="flex gap-3">
                <MapPin className="mt-0.5 h-4 w-4 shrink-0 text-blue-400" />
                <span className="text-slate-300" data-testid="footer-address">{BUSINESS.address}</span>
              </li>
              <li>
                <a
                  href={`tel:${BUSINESS.phoneRaw}`}
                  className="flex items-center gap-3 text-slate-300 hover:text-white"
                  data-testid="footer-phone"
                >
                  <Phone className="h-4 w-4 text-blue-400" /> {BUSINESS.phone}
                </a>
              </li>
              <li>
                <a
                  href={`mailto:${BUSINESS.email}`}
                  className="flex items-center gap-3 break-all text-slate-300 hover:text-white"
                  data-testid="footer-email"
                >
                  <Mail className="h-4 w-4 text-blue-400" /> {BUSINESS.email}
                </a>
              </li>
            </ul>
          </div>

          <div>
            <div className="font-heading text-sm font-bold uppercase tracking-[0.2em] text-white">
              Explore
            </div>
            <ul className="mt-5 space-y-3 text-sm">
              <li><a href="#offer" className="text-slate-300 hover:text-white" data-testid="footer-link-offer">Lagan Combo Offer</a></li>
              <li><a href="#categories" className="text-slate-300 hover:text-white" data-testid="footer-link-categories">Categories</a></li>
              <li><a href="#brands" className="text-slate-300 hover:text-white" data-testid="footer-link-brands">Brands</a></li>
              <li><a href="#about" className="text-slate-300 hover:text-white" data-testid="footer-link-about">About</a></li>
              <li><a href="#contact" className="text-slate-300 hover:text-white" data-testid="footer-link-contact">Contact</a></li>
            </ul>

            <a
              href={BUSINESS.instagram}
              target="_blank"
              rel="noopener noreferrer"
              className="mt-6 inline-flex items-center gap-2 rounded-full border border-slate-700 bg-slate-800/60 px-4 py-2 text-sm font-semibold text-white hover:bg-slate-800"
              data-testid="footer-instagram"
            >
              <Instagram className="h-4 w-4 text-pink-400" /> {BUSINESS.instagramHandle}
            </a>
          </div>
        </div>
      </div>
      <div className="border-t border-slate-800">
        <div className="container-b flex flex-col items-start justify-between gap-2 py-5 text-xs text-slate-500 sm:flex-row sm:items-center">
          <span>© {new Date().getFullYear()} Bhadani Electronics and Home Appliances. All rights reserved.</span>
          <span>Fatehpur · Gaya · Bihar 824232</span>
        </div>
      </div>
    </footer>
  );
}
